import React from "react";

interface CardGradientProps {
  className?: string;
  width?: string | number;
  height?: string | number;
}

const Whitepaper: React.FC<CardGradientProps> = ({
  className,
  width = "18",
  height = "19",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="2"
        y="2"
        width="14"
        height="15"
        rx="3"
        stroke="#FFA686"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6 6H12"
        stroke="#CFB2FF"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6 10H12"
        stroke="#CFB2FF"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default Whitepaper;
